import React from "react";

const CardSkeleton = () => {
  return (
    <div className="flex flex-col p-6 transition-all duration-300 transform bg-white border rounded-lg bg-primary/10 dark:bg-primary/20 animate-pulse">
      <div className="h-6 bg-gray-200 dark:bg-gray-600 rounded w-24 mb-3"></div>
      <div className="h-9 w-9 bg-gray-200 dark:bg-gray-600 rounded-full"></div>
    </div>
  );
};

export default CardSkeleton;
